export const loader_color = '#2980b9'
export const loader_size = '64px'
export const loader_margin = '4px'




/** WEBPACK FOOTER **
 ** ./src/components/ProfileTable/style.js
 **/